import { powerBiReportExportReducer } from 'src/app/root-store/reporting-store/reducers/powerbi-report-export.reducer';

export const reportingReducer = {
    export: powerBiReportExportReducer
};
